export const qkBaseCountry = ['countries']
